var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:_vm.$style.btn,attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('reset')}}},[_vm._v("\n    "+_vm._s(_vm.$trlMessage('autocomplete.reset'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }